export * from './triangle.model';
export { createTriangle } from './triangle.creator';
